import { TimelineEventOptionsEnum } from './OpportunityTimeline.types'
import {
  EventTypeVariantEnum,
  EventTypeVariantLiteral,
} from './TimelineEvent/TimelineEvent.types'

export const isEmailCapturedEvent = (eventType: string): boolean => {
  return eventType === TimelineEventOptionsEnum.LEAD_CAPTURED_AT
}

export const isMeetingBookedEvent = (eventType: string): boolean => {
  return eventType === TimelineEventOptionsEnum.MEETING_BOOKED_AT
}

export const isConversationCreatedEvent = (eventType: string): boolean => {
  return eventType === TimelineEventOptionsEnum.CONVERSATION_CREATED_AT
}

export const getEventType = (
  timelineEventOption: TimelineEventOptionsEnum
): EventTypeVariantLiteral => {
  if (isEmailCapturedEvent(timelineEventOption)) {
    return EventTypeVariantEnum.emailCaptured
  }
  if (isMeetingBookedEvent(timelineEventOption)) {
    return EventTypeVariantEnum.meeting
  }
  if (isConversationCreatedEvent(timelineEventOption)) {
    return EventTypeVariantEnum.conversation
  }
  return EventTypeVariantEnum.lifecycle
}
